export const socialsData = {
    github: 'https://github.com/19salonitomar',
    linkedIn: 'https://www.linkedin.com/in/saloni-tomar-68821423a/',
    twitter: 'https://x.com/t03015843',
    medium: 'https://medium.com/@salonitomar5813'
}